import { fmtDate } from "utils/date";
import React, { useState, useEffect } from "react";
import {
  Button, FormGroup, Label, Input, Row, Col, Table, Form
} from "reactstrap";
import { AlumnoService } from "service/AlumnoService";
import FSelect from "components/Select/FSelect";
import FDateInput from "components/DateInput/FDateInput";

const alumnoService = new AlumnoService();

const emptyPago = {
  montoapagar: "",
  numerocuota: "",
  fechaPago: "",
  fechaVencimiento: "",
  numerorecibopago: "",
  observacion: "",
  estado: "Pagado"
};

const PanelPagos = ({ matriculaId, alumnoNombre, onClose }) => {
  const [listPagos, setListPagos] = useState([]);
  const [pago, setPago] = useState(emptyPago);
  const [idPago, setIdPago] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (matriculaId) {
      loadPagos();
      resetForm();
    }
  }, [matriculaId]);

  const loadPagos = async () => {
    try {
      const res = await alumnoService.getPagoMatriculaPorIdMatricula({ matricula: matriculaId });
      setListPagos(res?.data || []);
    } catch (error) {
      console.error("Error cargando pagos:", error);
    }
  };

  const resetForm = () => {
    setPago(emptyPago);
    setIdPago(null);
    setShowForm(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPago(prev => ({ ...prev, [name]: value }));
  };

  const handleEdit = (item) => {
    setPago({
      montoapagar: item.montoapagar || "",
      numerocuota: item.numerocuota || "",
      fechaPago: item.fechaPago ? item.fechaPago.split('T')[0] : "",
      fechaVencimiento: item.fechaVencimiento ? item.fechaVencimiento.split('T')[0] : "",
      numerorecibopago: item.numerorecibopago || "",
      observacion: item.observacion || "",
      estado: item.estado || "Pagado"
    });
    setIdPago(item._id);
    setShowForm(true);
  };

  const handleSave = async () => {
    try {
      const dto = { ...pago, matricula: matriculaId };
      let res;
      if (idPago) {
        dto._id = idPago;
        res = await alumnoService.updatePagoMatricula(dto);
      } else {
        res = await alumnoService.addPagoMatricula(dto);
      }
      if (res?.confirmation === "success") {
        resetForm();
        loadPagos();
      }
    } catch (error) {
      console.error("Error guardando pago:", error);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span className="text-muted" style={{ fontSize: "0.85rem" }}>Alumno: {alumnoNombre}</span>
        {!showForm && (
          <Button color="success" size="sm" onClick={() => setShowForm(true)}>
            <i className="tim-icons icon-simple-add mr-1" /> Registrar Pago
          </Button>
        )}
      </div>

      {showForm && (
        <div className="p-3 border rounded mb-3">
          <h6 className="title">{idPago ? "Editar Pago" : "Nuevo Pago"}</h6>
          <Form>
            <Row>
              <Col md="4">
                <FormGroup>
                  <Label>Cuota N°</Label>
                  <Input type="number" name="numerocuota" value={pago.numerocuota} onChange={handleChange} />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Monto (S/)</Label>
                  <Input type="number" name="montoapagar" value={pago.montoapagar} onChange={handleChange} />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>N° Recibo</Label>
                  <Input type="text" name="numerorecibopago" value={pago.numerorecibopago} onChange={handleChange} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <FormGroup>
                  <Label>Fecha de Pago</Label>
                  <FDateInput name="fechaPago" value={pago.fechaPago} onChange={handleChange} />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Fecha de Vencimiento</Label>
                  <FDateInput name="fechaVencimiento" value={pago.fechaVencimiento} onChange={handleChange} />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Estado</Label>
                  <FSelect
                    name="estado"
                    value={pago.estado}
                    onChange={handleChange}
                    options={[
                      { value: "Pagado", label: "Pagado" },
                      { value: "Pendiente", label: "Pendiente" },
                      { value: "Vencido", label: "Vencido" },
                    ]}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <FormGroup>
                  <Label>Observación</Label>
                  <Input type="textarea" name="observacion" value={pago.observacion} onChange={handleChange} rows="2" />
                </FormGroup>
              </Col>
            </Row>
            <div className="d-flex justify-content-end" style={{ gap: "8px" }}>
              <Button color="secondary" size="sm" onClick={resetForm}>Cancelar</Button>
              <Button color="primary" size="sm" onClick={handleSave}>Guardar Pago</Button>
            </div>
          </Form>
        </div>
      )}

      <Table responsive size="sm">
        <thead className="text-primary">
          <tr>
            <th>Cuota</th>
            <th>Monto</th>
            <th>Fecha Pago</th>
            <th>Vencimiento</th>
            <th>Recibo</th>
            <th>Estado</th>
            <th className="text-right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {listPagos.map((p, idx) => (
            <tr key={idx}>
              <td>{p.numerocuota}</td>
              <td>S/ {p.montoapagar}</td>
              <td>{fmtDate(p.fechaPago)}</td>
              <td>{fmtDate(p.fechaVencimiento)}</td>
              <td>{p.numerorecibopago || "-"}</td>
              <td>
                {p.estado === "Pagado" && <span className="text-success">Pagado</span>}
                {p.estado === "Pendiente" && <span className="text-warning">Pendiente</span>}
                {p.estado === "Vencido" && <span className="text-danger">Vencido</span>}
                {!p.estado && "-"}
              </td>
              <td className="text-right">
                <Button
                  color="info" size="sm" className="btn-icon btn-link"
                  title="Editar pago"
                  onClick={() => handleEdit(p)}
                >
                  <i className="tim-icons icon-pencil" />
                </Button>
              </td>
            </tr>
          ))}
          {listPagos.length === 0 && (
            <tr>
              <td colSpan="7" className="text-center text-muted">No hay pagos registrados</td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default PanelPagos;
